import {put,takeLatest,call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    GET_TABLES,
    GET_TABLES_SUCCESS,
    GET_TABLES_ERROR
}
    from "../../actions/table";

function* getTablesSaga(action) {
    try {
        const data=yield call(tableService.GetTables,action.payload)
        yield put({
            type: GET_TABLES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_TABLES_ERROR,error: error.data
        });
    }
}


export function* getTablesSagaWatcher() {
    yield takeLatest(GET_TABLES,getTablesSaga);
}